import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_VISITA_CUMPLIMIENTO_INDICACION_AE, { adaptAddVisitaCumplimientoIndicacionInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaCumplimientoIndicacionAE";
import { useStepSave } from "../../../../hooks/useStepSave";

import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function CumplimientoDeLaIndicacion({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VISITA_CUMPLIMIENTO_INDICACION_AE);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia]);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { ...adaptAddVisitaCumplimientoIndicacionInput(formData) } });

    const idCumplimientoIndicacionNueva = data?.saveVisitaCumplimientoIndicacionAE?.idCumplimientoIndicacion;
    if (!idCumplimientoIndicacionNueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idCumplimientoIndicacion: idCumplimientoIndicacionNueva
    }));

  });


  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'cumplimientoDeLaIndicacion',
      stepName: 'Cumplimiento de la indicación',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox title="Cumplimiento de la indicación">
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "cambioIndicacionSemana",
  displayName: "¿Tuvo algún cambio de indicación en la última semana?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "dificultadCumplimiento",
  displayName: "¿Se presentó alguna dificultad en el cumplimiento de lo indicado?",
  longLabel: true,
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "indicacionActual",
  displayName: "¿Qué indicación está realizando?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "volumenDiario",
  displayName: "¿Cuánto alimento usa por día?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "bolsaUtilizada",
  displayName: "¿Qué alimento está utilizando?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "complementaViaOral",
  displayName: "¿Complementa por vía Oral?",
  type: "boolean",
  lightTitle: true,
  required: true
}];